module.exports = __webpack_public_path__ + "img/img_works11.75c01efc.jpg";